import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { blogPosts } from "@/data/blog";

const ROUTE_NAMES: Record<string, string> = {
  "/about": "About",
  "/services": "Services",
  "/government": "Partnership Opportunities",
  "/for-practitioners": "For Practitioners",
  "/member-dashboard": "Member Dashboard",
  "/blog": "Blog",
  "/events": "Event Calendar",
  "/careers": "Careers",
  "/contact": "Contact Us",
  "/auth": "Sign In",
  "/my-bookings": "My Bookings",
};

const BASE_URL = "https://www.hwhctherapy.com";

function buildBreadcrumbs(pathname: string) {
  // Blog post: /blog/:slug → Home → Blog → Post Title
  const blogMatch = pathname.match(/^\/blog\/(.+)$/);
  if (blogMatch) {
    const slug = blogMatch[1];
    const post = blogPosts.find((p) => p.slug === slug);
    if (post) {
      return [
        { name: "Home", item: BASE_URL },
        { name: "Blog", item: `${BASE_URL}/blog` },
        { name: post.title, item: `${BASE_URL}${pathname}` },
      ];
    }
  }

  // Standard pages
  const pageName = ROUTE_NAMES[pathname];
  if (pageName) {
    return [
      { name: "Home", item: BASE_URL },
      { name: pageName, item: `${BASE_URL}${pathname}` },
    ];
  }

  return null;
}

const BreadcrumbSchema = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const crumbs = buildBreadcrumbs(pathname);
    if (!crumbs || pathname === "/") {
      const existing = document.getElementById("breadcrumb-jsonld");
      if (existing) existing.remove();
      return;
    }

    const schema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: crumbs.map((c, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: c.name,
        item: c.item,
      })),
    };

    let script = document.getElementById("breadcrumb-jsonld") as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.id = "breadcrumb-jsonld";
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);

    return () => {
      const el = document.getElementById("breadcrumb-jsonld");
      if (el) el.remove();
    };
  }, [pathname]);

  return null;
};

export default BreadcrumbSchema;
